const $inject = ['$filter', 'moment'];

const lbTripOptionCarFormItemCtrl = function ($filter, moment) {
  let vm = this;

  const timeFormat = $filter('translate')('dates.TimeFormatLong');

  vm.flightDateTimeFormat = `DD MMM[,] YYYY ${timeFormat}`;
};

lbTripOptionCarFormItemCtrl.$inject = $inject;

export default lbTripOptionCarFormItemCtrl;



// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsCarFormItemCtrl.js